import {
  IconButton,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";

import Labels from "lang/Labels_en";

interface IFilesComponent {
  files: any;
  deleteFile: (id: number) => void;
}

export const FilesComponent = ({ files, deleteFile }: IFilesComponent) => (
  <TableContainer component={Paper}>
    <Table aria-label="simple table">
      <TableHead>
        <TableRow>
          <TableCell>{Labels.TITLE}</TableCell>
          <TableCell>{Labels.FILE_TYPE}</TableCell>
          <TableCell>{Labels.ACTION}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {files.map((file: any) => (
          <TableRow key={file.id}>
            <TableCell style={{ paddingTop: 0, paddingBottom: 0 }}>
              <Link href={file?.location} color="inherit" component="a" target="_blank">
                {file?.name}
              </Link>
            </TableCell>
            <TableCell style={{ paddingTop: 0, paddingBottom: 0 }}>{file.type}</TableCell>
            <TableCell style={{ paddingTop: 0, paddingBottom: 0 }}>
              <IconButton aria-label="delete" onClick={() => deleteFile(file.id)}>
                <DeleteIcon />
              </IconButton>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);
